export default __webpack_public_path__ + "static/project-image-bd757792a9add60073ce995713be30d2.png";